import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { featuredProject } from "@/data/projects";
import { Reveal } from "@/components/Motion";

const FeaturedProject = () => {
  const project = featuredProject;
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="project-in-de-kijker" ref={ref} className="relative bg-white py-24 md:py-32 lg:py-40">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16">
        <Reveal className="flex items-center gap-4 mb-12 md:mb-16">
          <span className="h-px w-12 bg-forest" />
          <span className="font-body text-xs tracking-[0.25em] uppercase text-forest">
            Project in de kijker
          </span>
        </Reveal>

        <div className="grid lg:grid-cols-12 gap-8 lg:gap-6 items-end">
          <motion.a
            href={project.url}
            aria-label="Ontdek Project Doornzele"
            whileHover={{ y: -2 }}
            className="group lg:col-span-8 relative block overflow-hidden rounded-2xl md:rounded-[2rem] aspect-[4/3] lg:aspect-[16/11] shadow-[0_20px_60px_rgba(45,51,47,0.10)] transition-shadow duration-500 hover:shadow-[0_24px_65px_rgba(45,51,47,0.16)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-forest focus-visible:ring-offset-4"
          >
            <motion.img
              src={project.cover}
              alt="Render van Project Doornzele"
              style={{ y }}
              className="absolute inset-x-0 -top-[11%] h-[122%] w-full object-cover transition-[filter] duration-500 group-hover:brightness-95"
              loading="eager"
            />
          </motion.a>

          <div className="lg:col-span-4 lg:pb-6">
            <Reveal delay={0.1}>
              <p className="font-body text-sm text-slate2 mb-3">
                {project.location}
              </p>
              <h2 className="font-heading font-light tracking-tight text-4xl md:text-5xl lg:text-6xl leading-[1.1] text-ink text-balance mb-6">
                {project.name}
              </h2>
              <p className="font-body text-slate2 leading-relaxed mb-8">
                {project.intro}
              </p>
              <a
                data-testid="featured-project-btn"
                href={project.url}
                className="group inline-flex items-center gap-3 rounded-cta border border-ink/15 bg-transparent px-7 py-3.5 text-ink font-body text-sm font-medium tracking-wide transition-all duration-300 hover:bg-offwhite hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-forest/50 focus-visible:ring-offset-2"
              >
                Ontdek Project Doornzele
                <ArrowRight
                  size={18}
                  aria-hidden="true"
                  className="transition-transform duration-300 group-hover:translate-x-1"
                />
              </a>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedProject;
